<template lang="html">
  <div
    class="organization-profile"
    v-if="isAdmin">
    <div class="card">
      <div class="card-header">
        <h3>Editar dados da Organização</h3>
      </div>
      <div class="card-body">
        <form
          ref="editOrganizationForm"
          class="text-center"
          @submit.prevent="onSubmit"
          @keydown.enter.prevent="onSubmit">
          <div
            v-if="error"
            class="alert alert-danger text-center"
            role="alert">
            <span v-html="error.message" />
          </div>
          <div class="form-group row">
            <label
              for="name"
              class="col-sm-4 col-form-label">Nome</label>
            <div class="col-sm-8">
              <input
                id="name"
                type="text"
                class="form-control organization-name"
                v-model="name"
                required>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="email"
              class="col-sm-4 col-form-label">Email</label>
            <div class="col-sm-8">
              <input
                id="email"
                type="text"
                class="form-control organization-email"
                v-model="email"
                required>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="phone"
              class="col-sm-4 col-form-label">Telefone</label>
            <div class="col-sm-8">
              <input
                id="phone"
                type="text"
                class="form-control organization-phone"
                v-model="phone">
            </div>
          </div>
          <div class="buttons flex">
            <button
              type="submit"
              class="btn btn-primary organization-save"
              @click.prevent="onSubmit">
              Atualizar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="editOrganizationSuccess"
      ref="editOrganizationSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>Dados da Organização atualizados com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="onModalOk">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'OrganizationProfile',
  data () {
    return {
      name: null,
      email: null,
      phone: null,
      error: null
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getOrganization()
    })
  },
  methods: {
    onSubmit () {
      const form = this.$refs.editOrganizationForm
      this.error = null
      if (form.checkValidity()) {
        let paramsToUpdate = {
          name: this.name,
          email: this.email,
          phone: this.phone
        }
        loopback
          .patch('/accounts', paramsToUpdate)
          .then(organization => {
            this.$store.commit('auth/setOrganization', organization)
            this.setOrganization(organization)
            $(this.$refs.editOrganizationSuccess).modal('show')
          })
          .catch(err => {
            this.error = err
            if (err && err.details) {
              this.error = {
                message: Object.values(err.details.messages).join('<br />')
              }
            }
          })
      } else {
        this.error = {
          message: 'O campo nome e email são obrigatórios'
        }
      }
    },
    getOrganization () {
      this.error = null
      const organization = this.$store.state.auth.organization
      if (organization) {
        this.setOrganization(organization)
      }
    },
    setOrganization (organization) {
      this.name = organization.name
      this.email = organization.email
      this.phone = organization.phone
    },
    onModalOk () {
      this.$router.go(0)
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/Profile.vue